namespace GeniuzPOS.Lookups {
    export interface CusProductSalesBeforeFlagRow {
        CusProductSalesBeforeFlag?: string;
        LookupName?: string;
    }

    export namespace CusProductSalesBeforeFlagRow {
        export const idProperty = 'CusProductSalesBeforeFlag';
        export const nameProperty = 'LookupName';
        export const localTextPrefix = 'Lookups.CusProductSalesBeforeFlag';
        export const lookupKey = 'Lookups.CusProductSalesBeforeFlag';

        export function getLookup(): Q.Lookup<CusProductSalesBeforeFlagRow> {
            return Q.getLookup<CusProductSalesBeforeFlagRow>('Lookups.CusProductSalesBeforeFlag');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            CusProductSalesBeforeFlag = "CusProductSalesBeforeFlag",
            LookupName = "LookupName"
        }
    }
}
